import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Button, Typography } from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/People";
import TextField from "@material-ui/core/TextField";
import {
  acceptRequest,
  cancelRequest,
  deleteTeam,
  denyRequest,
  joinTeam,
  kickMember,
  leaveTeam,
} from "../services/firebase";
import { UserContext } from "../providers/UserProvider";
import { Link, Redirect } from "react-router-dom";
import StarOutlineIcon from "@material-ui/icons/StarOutline";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import IconButton from "@material-ui/core/IconButton";
import SettingsIcon from "@material-ui/icons/Settings";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: "40px",
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 480,
  },
  loader: {
    marginTop: theme.spacing(4),
  },
  cancel: {},
  join: {
    width: "100%",
    height: "100%",
  },
  teamMember: {
    display: "flex",
    alignItems: "center",
    margin: "10px auto",
  },
}));

export default function Dashboard() {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [teamId, setTeamId] = useState("");
  const userState = useContext(UserContext);
  const [memberInfo, setMemberInfo] = useState(userState.memberInfo);

  if (!userState.doc || !userState.doc.exists) {
    return <Redirect to="/register" />;
  }
  if (userState.doc.data().teamId) {
    let requestsList = [];
    for (let k in userState.requests) {
      requestsList.push({ info: userState.requests[k], uid: k });
    }

    const onAccept = (userId) => {
      acceptRequest(
        userState.user,
        userState.teamDoc.data().code,
        userState.doc.data().teamId,
        userId
      );
    };
    const onDeny = (userId) => {
      denyRequest(userState.user, userState.teamDoc.data().code, userId);
    };

    const onDelete = () => {
      deleteTeam(
        userState.user,
        userState.teamDoc.data().code,
        userState.doc.data().teamId
      );
    };

    const onLeave = () => {
      leaveTeam(userState.user, userState.teamDoc);
    };

    const onKick = (uid) => {
      delete memberInfo[uid];
      setMemberInfo(memberInfo);

      kickMember(userState.teamDoc, uid);
    };

    return (
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3}>
          {/* Chart */}
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <div style={{ flex: 1 }}>
                <Typography
                  component="h2"
                  variant="h4"
                  color="primary"
                  gutterBottom
                >
                  Team {userState.teamDoc?.data()?.teamName}
                </Typography>
                <Typography component="p" variant="h6">
                  Team ID: {userState.doc.data().teamId}
                  {userState.user.uid ===
                  userState.teamDoc?.data()?.teamCaptain ? (
                    <IconButton
                      color="inherit"
                      component={Link}
                      to="/team"
                      className={classes.desktopOnly}
                    >
                      <SettingsIcon />
                    </IconButton>
                  ) : (
                    <React.Fragment />
                  )}
                </Typography>
                <Typography component="p" variant="h6" gutterBottom>
                  Code: {userState.teamDoc?.data()?.code}
                </Typography>
                <Typography component="p" variant="subtitle1">
                  Players may join the team until August 5, 2021.
                </Typography>
                {Object.keys(memberInfo).map((uid, index) => (
                  <div key={uid} className={classes.teamMember}>
                    <div style={{ flex: "auto" }} />
                    {uid === userState.teamDoc?.data()?.teamCaptain ? (
                      <StarOutlineIcon style={{ marginRight: "10px" }} />
                    ) : (
                      <div />
                    )}
                    {userState.user.uid ===
                      userState.teamDoc?.data()?.teamCaptain &&
                    uid !== userState.user.uid ? (
                      <HighlightOffIcon
                        style={{ cursor: "pointer", marginRight: "10px" }}
                        onClick={() => onKick(uid)}
                      />
                    ) : (
                      <div />
                    )}
                    <Typography component="p" variant="h6">
                      {memberInfo[uid].fullName}
                    </Typography>
                    <div style={{ flex: "auto" }} />
                  </div>
                ))}
                {userState.teamDoc?.data() &&
                userState.user.uid === userState.teamDoc.data().teamCaptain ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.cancel}
                    onClick={onDelete}
                  >
                    <HighlightOffIcon
                      style={{ marginLeft: "-7px", marginRight: "10px" }}
                    />
                    Delete Team
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.cancel}
                    onClick={onLeave}
                  >
                    <ExitToAppIcon
                      style={{ marginLeft: "-7px", marginRight: "10px" }}
                    />
                    Leave Team
                  </Button>
                )}
                {userState.teamDoc?.data() &&
                userState.user.uid === userState.teamDoc.data().teamCaptain ? (
                  <div>
                    <hr style={{ margin: "20px 0px" }} />
                    <Typography
                      component="h2"
                      variant="h5"
                      color="primary"
                      gutterBottom
                    >
                      Pending Requests
                    </Typography>
                    {requestsList.length === 0 ? (
                      <Typography component="p" variant="subtitle1">
                        You have no pending requests.
                      </Typography>
                    ) : (
                      <div>
                        {requestsList.map((info) => (
                          <div key={info.uid} className={classes.teamMember}>
                            <div style={{ flex: "auto" }} />
                            <CheckCircleOutlineIcon
                              style={{ cursor: "pointer" }}
                              onClick={() => onAccept(info.uid)}
                            />
                            <HighlightOffIcon
                              style={{ cursor: "pointer", marginRight: "10px" }}
                              onClick={() => onDeny(info.uid)}
                            />
                            <Typography component="p" variant="h6">
                              {info.info.fullName}
                            </Typography>
                            <div style={{ flex: "auto" }} />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  }
  if (userState.doc.data().teamRequest) {
    const onCancel = () => {
      cancelRequest(userState.user, userState.doc.data().teamRequest);
    };
    return (
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3}>
          {/* Chart */}
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <div style={{ flex: 1 }}>
                <Typography
                  component="h2"
                  variant="h4"
                  color="primary"
                  gutterBottom
                >
                  Pending request
                </Typography>
                <Typography component="p" variant="h6" gutterBottom>
                  Code: {userState.doc.data().teamRequest}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.cancel}
                  onClick={onCancel}
                >
                  <PeopleIcon
                    style={{ marginLeft: "-7px", marginRight: "10px" }}
                  ></PeopleIcon>
                  Cancel Request
                </Button>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  }
  const onJoinTeam = (e) => {
    e.preventDefault();
    joinTeam(userState.user, userState.doc.data().fullName, teamId);
    setTeamId("");
  };
  return (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={3}>
        {/* Chart */}
        <Grid item xs={12} md={6}>
          <Paper className={fixedHeightPaper}>
            <div style={{ height: "100px" }} />
            <div>
              <Typography
                component="h2"
                variant="h4"
                color="primary"
                gutterBottom
              >
                Register a team
              </Typography>
              <Typography component="p" variant="subtitle1">
                Registration is now closed.
              </Typography>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper className={fixedHeightPaper}>
            <div style={{ height: "100px" }} />
            <div>
              <Typography
                component="h2"
                variant="h4"
                color="primary"
                gutterBottom
              >
                Join a team
              </Typography>
              <Typography component="p" variant="subtitle1">
                Please join a team by August 5, 2021.
              </Typography>
              <form onSubmit={onJoinTeam}>
                <Grid
                  container
                  spacing={2}
                  style={{ paddingTop: "20px", paddingBottom: "20px" }}
                >
                  <Grid item xs={12} lg={8}>
                    <TextField
                      variant="outlined"
                      autoComplete="off"
                      required
                      fullWidth
                      id="teamID"
                      label="Team Code"
                      name="teamID"
                      value={teamId}
                      onChange={(e) => {
                        setTeamId(e.target.value.trim());
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.join}
                      type="submit"
                    >
                      <PeopleIcon
                        style={{ marginLeft: "-7px", marginRight: "10px" }}
                      ></PeopleIcon>
                      Join Team
                    </Button>
                  </Grid>
                </Grid>
              </form>
              <Typography component="p" variant="subtitle2">
                <em>
                  {" "}
                  Teams with less than 2 players at that time will be dropped.{" "}
                </em>
              </Typography>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
